"use client";

/**
 * Mounts ONE WebVersionModal for the whole app and opens it whenever
 * `allowCheckout()` blocks a purchase on native.
 *
 * Mounted globally (not just under /m) on purpose: several purchase surfaces
 * live on desktop routes that still render inside the native shell — the A2P
 * wizard, the Lead Sniper wallet, and the bulk area-code banner, which can fire
 * from ANY screen.
 */
import { useEffect, useState } from "react";
import {
  WebVersionModal,
  type WebVersionFeature,
} from "@/components/mobile/WebVersionModal";
import { NATIVE_PURCHASE_BLOCKED_EVENT } from "@/app/_module/utils/nativeCheckoutGuard";

export function NativeCheckoutGuardHost() {
  const [open, setOpen] = useState(false);
  const [feature, setFeature] = useState<WebVersionFeature>("payment");

  useEffect(() => {
    const onBlocked = (e: Event) => {
      const detail = (e as CustomEvent<{ feature?: WebVersionFeature }>).detail;
      setFeature(detail?.feature ?? "payment");
      setOpen(true);
    };
    window.addEventListener(NATIVE_PURCHASE_BLOCKED_EVENT, onBlocked);
    return () => window.removeEventListener(NATIVE_PURCHASE_BLOCKED_EVENT, onBlocked);
  }, []);

  return <WebVersionModal open={open} onOpenChange={setOpen} feature={feature} />;
}
